import { Header, Segment } from "semantic-ui-react";
import styled from "styled-components";
import CompanyLogo from "./CompanyLogo";

const SegmentFlex = styled(Segment)`
  display: flex;
`;

const HeaderVerticalCenter = styled(Header)`
  margin-bottom: 0 !important;
  align-self: center;
`;

const Right = styled.div`
  margin-left: auto;
  margin-right: 0;
`;

const SegmentMobileHeading = ({ color, header, logo_url, logo_size }) => {
  return (
    <SegmentFlex color="black">
      <HeaderVerticalCenter as="h5">{header}</HeaderVerticalCenter>
      <Right>
        <CompanyLogo url={logo_url} size={logo_size} />
      </Right>
    </SegmentFlex>
  );
};

export default SegmentMobileHeading;
